// Vendor imports
const PropTypes = require('prop-types')
const classNames = require('classnames')
// Shared imports
const BemEntity = require('shared/bem')
const { TYPES: modelTypes } = require('shared/model-types')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const morePropTypes = require('client-v2/common/utils/prop-types')
const { ARTICLE_HAS_MIX_CHANGE_PENDING } = require('client-v2/common/models/article/actions')
const { COLLECTION_FOLLOWING_CHANGE_PENDING } = require('client-v2/common/models/collection/actions')
const { INTEREST_FOLLOWING_CHANGE_PENDING } = require('client-v2/common/models/interest/actions')
const { USER_FOLLOWING_CHANGE_PENDING } = require('client-v2/common/models/user/actions')

const bem = BemEntity('ModelToggleButton')

function ModelToggleButton(props) {
  const {
    pending, checked, unchecked,
    label, title, action
  } = modelTypeProps(props)
  return tag(props.as, {
    className: classNames(
      props.className,
      bem.block({
        action,
        pending,
        checked,
        unchecked
      })
    ),
    title,
    forwardedRef: props.forwardedRef,
    onClick: pending ? null : props.onClick
  },
    tag('label', {
      className: bem.element('label')
    },
      label
    )
  )
}

const propsByModelType = {
  [modelTypes.INTEREST]: {
    action: 'interest-follow',
    uncheckedLabel: 'Follow',
    uncheckedTitle: 'Follow this interest to see more like this',
    checkedLabel: 'Following',
    checkedTitle: 'You are following this interest',
    pendingValue: INTEREST_FOLLOWING_CHANGE_PENDING
  },
  [modelTypes.MIX]: {
    action: 'subscribe',
    uncheckedLabel: 'Subscribe',
    uncheckedTitle: 'Subscribe to this collection',
    checkedLabel: 'Subscribed',
    checkedTitle: 'You are subscribed to this collection',
    pendingValue: COLLECTION_FOLLOWING_CHANGE_PENDING
  },
  [modelTypes.USER]: {
    action: 'user-follow',
    uncheckedLabel: 'Follow',
    uncheckedTitle: 'Follow this person to see more of their posts',
    checkedLabel: 'Following',
    checkedTitle: 'You are following this person',
    pendingValue: USER_FOLLOWING_CHANGE_PENDING
  }
}

function modelTypeProps({ modelType, checked }) {
  const modelTypeProps = propsByModelType[modelType]
  if (!modelTypeProps) {
    throw new Error(`Unsupported modelType: ${modelType}`)
  }
  if (checked === modelTypeProps.pendingValue) {
    return {
      pending: true,
      label: '',
      title: 'Just a moment...'
    }
  }
  if (checked) {
    return {
      checked: true,
      label: modelTypeProps.checkedLabel,
      title: modelTypeProps.checkedTitle,
      action: modelTypeProps.action
    }
  }
  return {
    unchecked: true,
    label: modelTypeProps.uncheckedLabel,
    title: modelTypeProps.uncheckedTitle,
    action: modelTypeProps.action
  }
}

const checkedValues = [
  true,
  false,
  ARTICLE_HAS_MIX_CHANGE_PENDING,
  COLLECTION_FOLLOWING_CHANGE_PENDING,
  INTEREST_FOLLOWING_CHANGE_PENDING,
  USER_FOLLOWING_CHANGE_PENDING
]

const modelTypeValues = [
  modelTypes.ARTICLE,
  modelTypes.INTEREST,
  modelTypes.MIX,
  modelTypes.USER
]

ModelToggleButton.propTypes = {
  // Values
  as: PropTypes.elementType.isRequired,
  className: PropTypes.string,
  checked: PropTypes.oneOf(checkedValues).isRequired,
  forwardedRef: morePropTypes.domRef,
  modelType: PropTypes.oneOf(modelTypeValues).isRequired,
  onClick: PropTypes.func.isRequired
}

ModelToggleButton.withModelToggle = (modelType, buttonComponent) => {
  const highOrderComponent = props => {
    return tag(ModelToggleButton, {
      ...props,
      as: buttonComponent,
      modelType
    })
  }
  const buttonName = buttonComponent.displayName || buttonComponent.name
  highOrderComponent.displayName = `withModelToggle(${buttonName}, ${modelType})`
  return highOrderComponent
}

module.exports = ModelToggleButton
